import { UserContext } from "@/context/User/UserContext";
import { getSingleDesignation } from "@/services/Designation.service";
import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";
import { useParams } from "react-router-dom";
import EditDesignation from "../dialog/EditDesignation";

const Designation = () => {
	const { id } = useParams<{ id: string }>() as { id: string };
	const user = useContext(UserContext);

	const designation = useQuery({
		queryKey: ["designation", id],
		queryFn: () => getSingleDesignation(parseInt(id), user?.accessToken!),
		enabled: !!user?.accessToken,
		staleTime: 3000,
	});

	return (
		<>
			{designation.isLoading ? (
				<div className="grid gap-4 pt-4">
					{Array.from({ length: 2 }).map((_, num) => (
						<div key={num} className="h-12 w-full bg-gray-200 animate-pulse" />
					))}
				</div>
			) : designation.data ? (
				<>
					<div className="flex gap-3 items-end justify-between">
						<h1 className="font-medium text-4xl">
							Designation: {designation.data.designation}
						</h1>
						<EditDesignation user={user} designation={designation.data} />
					</div>
					<div className="border-y my-3 py-4 border-zinc-200">
						<div className="grid grid-cols-1 sm:grid-cols-2">
							<div className="flex gap-4">
								<div className="flex flex-col gap-2 text-zinc-500 font-light text-nowrap">
									<p>ID</p>
									<p>Designation</p>
								</div>
								<div className="flex flex-col gap-2">
									<p>{designation.data.designationid}</p>
									<p>{designation.data.designation}</p>
								</div>
							</div>
						</div>
					</div>
				</>
			) : null}
		</>
	);
};

export default Designation;
